import { render, staticRenderFns } from "./ComentarioPage.vue?vue&type=template&id=797a6c90"
import script from "./ComentarioPage.js?vue&type=script&lang=js&external"
export * from "./ComentarioPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports